// extracted by mini-css-extract-plugin
export var wrapper = "PageContent-module--wrapper--XGaZp";